import { Component } from 'react';
import { withRouter } from 'react-router-dom';

const SITE_URL = 'https://www.ctcae-cloud.com';
const GA_ID = 'G-SV0398FL1S';
const DEFAULT_IMAGE = `${SITE_URL}/preview.png`;

const ROUTE_SEO = {
    '/': {
        title: 'CTCAE v6 | Common Terminology Criteria for Adverse Events',
        description:
            'Browse CTCAE v6 adverse event terms by category, grade, and definition. Search MedDRA SOC codes and compare CTCAE v5 and v6 online.',
        path: '/ctcae6',
        robots: 'index, follow'
    },
    '/ctcae6': {
        title: 'CTCAE v6 Browser | Grades, Definitions & MedDRA Terms',
        description:
            'Search and browse CTCAE v6 (Common Terminology Criteria for Adverse Events). View grades 1–5, definitions, and MedDRA SOC categories online.',
        path: '/ctcae6',
        robots: 'index, follow'
    },
    '/ctcae5': {
        title: 'CTCAE v5 Browser | Grades, Definitions & MedDRA Terms',
        description:
            'Search and browse CTCAE v5.0 adverse event criteria. Explore categories, grades 1–5, definitions, and MedDRA codes online.',
        path: '/ctcae5',
        robots: 'index, follow'
    }
};

const DEFAULT_SEO = {
    title: 'CTCAE Cloud | CTCAE v5 & v6 Browser',
    description:
        'CTCAE Cloud helps clinicians and researchers browse CTCAE v5 and v6 terms, grades, and definitions online.',
    path: '/',
    robots: 'index, follow'
};

function upsertMeta(attr, key, content) {
    let element = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, key);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
}

function upsertLink(rel, href) {
    let element = document.head.querySelector(`link[rel="${rel}"]`);
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
    }
    element.setAttribute('href', href);
}

function upsertJsonLd(id, data) {
    let script = document.getElementById(id);
    if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
}

class Seo extends Component {
    getSeoConfig(pathname) {
        if (ROUTE_SEO[pathname]) {
            return ROUTE_SEO[pathname];
        }

        if (pathname.startsWith('/ctcae5')) {
            return ROUTE_SEO['/ctcae5'];
        }
        if (pathname.startsWith('/ctcae6')) {
            return ROUTE_SEO['/ctcae6'];
        }

        return DEFAULT_SEO;
    }

    updateHead(pathname) {
        const config = this.getSeoConfig(pathname);
        const canonicalUrl = `${SITE_URL}${config.path}`;

        document.title = config.title;

        upsertMeta('name', 'description', config.description);
        upsertMeta('name', 'robots', config.robots);
        upsertMeta('property', 'og:title', config.title);
        upsertMeta('property', 'og:description', config.description);
        upsertMeta('property', 'og:url', canonicalUrl);
        upsertMeta('property', 'og:type', 'website');
        upsertMeta('property', 'og:image', DEFAULT_IMAGE);
        upsertMeta('property', 'og:site_name', 'CTCAE Cloud');
        upsertMeta('property', 'og:locale', 'en_US');
        upsertMeta('name', 'twitter:card', 'summary_large_image');
        upsertMeta('name', 'twitter:title', config.title);
        upsertMeta('name', 'twitter:description', config.description);
        upsertMeta('name', 'twitter:image', DEFAULT_IMAGE);

        upsertLink('canonical', canonicalUrl);

        upsertJsonLd('seo-webpage-jsonld', {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: config.title,
            description: config.description,
            url: canonicalUrl,
            isPartOf: {
                '@type': 'WebSite',
                name: 'CTCAE Cloud',
                url: SITE_URL
            }
        });

        if (typeof window.gtag === 'function') {
            window.gtag('config', GA_ID, {
                page_path: pathname,
                page_title: config.title
            });
        }
    }

    componentDidMount() {
        this.updateHead(this.props.location.pathname);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.updateHead(this.props.location.pathname);
        }
    }

    render() {
        return null;
    }
}

export default withRouter(Seo);



// WEBPACK FOOTER //
// ./src/component/seo/seo.js